import { render, staticRenderFns } from "./FormResponseType5.vue?vue&type=template&id=6b17f0fb&scoped=true"
import script from "./FormResponseType5.vue?vue&type=script&lang=js"
export * from "./FormResponseType5.vue?vue&type=script&lang=js"
import style0 from "./FormResponseType5.vue?vue&type=style&index=0&id=6b17f0fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b17f0fb",
  null
  
)

export default component.exports